import httpClient from '../../services/httpClient';
import { GetCartResponse, Product as CartProduct } from './types';

// --- helpers ---
const toNumber = (value: unknown, fallback = 0): number => {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  };
  
  const normalizeProducts = (raw: any): CartProduct[] => {
    if (!raw) return [];
  
    const rawItems: any[] =
      Array.isArray(raw) ? raw :
      raw.products?.$values ??
      raw.items?.$values ??
      raw.products ??
      raw.items ??
      raw.bucket?.items ??
      raw.$values ??
      [];
  
    return rawItems
      .map((it: any): CartProduct | null => {
        const product = it?.product ?? it;
        if (!product) return null;
  
        const id = toNumber(product.productId ?? product.id ?? it?.id ?? it?.productId);
        if (id <= 0) return null;
  
        const price = toNumber(product.price);
        const quantity = toNumber(it?.quantity ?? it?.count ?? product.quantity, 1);
  
        return {
          id,
          name: String(product.name ?? ''),
          price,
          quantity,
          totalPrice: price * quantity,
          picture: String(product.picture ?? product.imageUrl ?? ''),
          description: String(product.description ?? ''),
          discountPercent: product.discountPercent == null ? null : toNumber(product.discountPercent),
          discountEndsAt: product.discountEndsAt ?? null,
        };
      })
      .filter((p): p is CartProduct => p !== null);
  };

// --- service ---
export const cartService = {
  // GET /api/Buckets/Get
  get: async (): Promise<GetCartResponse> => {
    const { data } = await httpClient.get('/api/Buckets/Get');

    const products = normalizeProducts(data);
    const userId = toNumber(data?.userId ?? data?.user?.id);

    return {
      userId,
      products,
      totalPrice: products.reduce((sum, p) => sum + p.totalPrice, 0),
    };
  },

  // POST /api/Buckets/AddToBucket?productId=123
  add: async (productId: number) => {
    const { data } = await httpClient.post('/api/Buckets/AddToBucket', null, {
      params: { productId },
    });
    return data;
  },

  // DELETE /api/Buckets/Remove?productId=123
  remove: async (productId: number) => {
    const { data } = await httpClient.delete('/api/Buckets/Remove', {
      params: { productId },
    });
    return data;
  },
};

export default cartService;
